/*
 * @providesModule Badge
 *
 */

import React from 'react';
import {StyleProp, TextStyle, ViewStyle} from 'react-native';
import {View, Text, StyleSheet} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import SkillzStyle from 'SkillzStyle';

const {fontBold} = SkillzStyle.fullStyles;

// Secondary Variant required secondaryText prop
// TODO: conditional props
type BadgeProps = {
  text: string;
  style?: StyleProp<ViewStyle>;
  leftComponent?: React.ReactNode;
  variant?: 'default' | 'secondary';
  secondaryText?: string;
  secondaryTextStyle?: StyleProp<TextStyle>;
  variantStyle?: StyleProp<ViewStyle>;
};

export function Badge({
  text,
  style,
  leftComponent,
  variant = 'default',
  variantStyle,
  secondaryText,
  secondaryTextStyle,
}: BadgeProps) {
  if (variant === 'secondary' && secondaryText) {
    return (
      <View style={[styles.secondaryVariantContainer, variantStyle]}>
        <LinearGradient
          locations={[0, 1]}
          colors={['#e9006c', '#a5019e']}
          useAngle={true}
          angle={178.1}
          style={[styles.secondaryVariantBadgeWrapper, style]}
        >
          {!!leftComponent && leftComponent}
          <Text style={styles.badgeText} allowFontScaling={false}>
            {text}
          </Text>
        </LinearGradient>
        <View style={styles.secondaryTextContainer}>
          {!!leftComponent && leftComponent}
          <Text
            style={[styles.secondaryVariantBadgeText, secondaryTextStyle]}
            allowFontScaling={false}
          >
            {secondaryText}
          </Text>
        </View>
      </View>
    );
  }

  return (
    <LinearGradient
      locations={[0, 1]}
      colors={['#e9006c', '#a5019e']}
      useAngle={true}
      angle={178.1}
      style={[styles.badgeWrapper, style]}
    >
      {!!leftComponent && leftComponent}
      <Text style={styles.badgeText} allowFontScaling={false}>
        {text}
      </Text>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  // DEFAULT VARIANT
  // ------------------------------------------------------------
  badgeWrapper: {
    borderRadius: 4.61,
    height: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
    paddingVertical: 3,
    backgroundColor: 'transparent',
  },
  badgeText: {
    fontSize: 13,
    letterSpacing: -0.6,
    lineHeight: 15.5,
    fontFamily: 'OpenSans-ExtraBold',
    color: '#fff',
    textAlign: 'center',
    textShadowColor: 'rgba(0, 0, 0, 0.25)',
    textShadowOffset: {
      width: 0,
      height: 0.7676662802696228,
    },
    textShadowRadius: 0.32,
    alignSelf: 'flex-start',
  },

  // SECONDARY VARIANT
  // ------------------------------------------------------------
  secondaryVariantContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  secondaryVariantBadgeWrapper: {
    borderTopLeftRadius: 4.61,
    borderBottomLeftRadius: 4.61,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
    paddingVertical: 3,
    backgroundColor: 'transparent',
  },

  secondaryVariantBadgeText: {
    ...fontBold,
    fontSize: 13,
    color: '#000',
    lineHeight: 15.5,
  },

  secondaryTextContainer: {
    backgroundColor: '#FFF',
    borderTopRightRadius: 4.61,
    borderBottomRightRadius: 4.61,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    height: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
    paddingVertical: 3,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 1,
  },
});
